import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
//import CashFlowTabs from '../../components/Cashflow/CashflowTabs';

import CashFlowTabs from '../../components/Cashflow/PaymentsTabs';

const Cashflow =() => {
    return(
      <>
      <Typography>
         <CashFlowTabs />
       </Typography>
       </>
       );
};
export default Cashflow;